import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"

import IndexBloc from "./Blocs/IndexBlock"

import Select from "react-select"

import TableActiveComponent from './Components/TableActiveComponent'

var reformatOptionsWU = function(workUnits) {
  return workUnits.map(function(workUnit) {
    var newObj = {};
    newObj["label"] = workUnit.work_unit_name_tabs;
    newObj["value"] = workUnit.work_unit_uuid;

    return newObj;
  });
};
var reformatOptionsStatus = function(EmployeeStatuss) {
    return EmployeeStatuss.map(function(EmployeeStatus) {
      var newObj = {};
      newObj["label"] = EmployeeStatus.employee_status_name;
      newObj["value"] = EmployeeStatus.employee_status_uuid;
  
      return newObj;
    });
  };
const IndexView = (props) => {
  
    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const inactiveRef = useRef();

    // Select
    const [optionUnits, setOptionUnits] = useState([
    ]);
    const [optionEmployeeStatuss, setOptionEmployeeStatus] = useState([
    ]);
    const [selectedUnit, setSelectedUnit] = useState("")
    const [selectedStatus, setSelectedStatus] = useState({
      label : "PNS",
      value : "2920a911-9b3f-42cf-ad91-d05cb4ab057b"
    })

    const handleSelectUnit = (selectedUnit) => {
      setSelectedUnit(selectedUnit)
    }
    const handleSelectStatus = (selectedStatus) => {
        setSelectedStatus(selectedStatus)
    }
    useEffect( () => {
        // get data unit
        indexBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response.result
                        setOptionUnits(
                          reformatOptionsWU(response)
                        )
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        indexBloc.EmployeeStatusChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response.result
                      setOptionEmployeeStatus(
                          reformatOptionsStatus(response)
                      )
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
  
      indexBloc.fetchWorkUnit({})
      indexBloc.fetchEmployeeStatus({})
    }, [])

    // Filter
    const [nip, setNip] = useState('')
    const [name, setName] = useState('')

    let additionalFilter = {
        nip: nip,
        name: name,
        work_unit: selectedUnit.value || "",
        employee_status_uuid: selectedStatus.value || ""
    };

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    function handleButtonSearch() {
      reloadActiveRef()
    }

    function handleButtonReset() {
      setNip('');
      setName('');
      setSelectedUnit('')
      setSelectedStatus('')
      reloadActiveRef()
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                {/* {
                                    (accessRole('create')) ?
                                        <Link to="home.html?create">
                                            <Button color="primary">New Sample</Button>
                                        </Link>
                                    : null
                                } */}
                                </div>
                                <CardTitle>List Data Pegawai</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Seluruh Pegawai
                                </CardSubtitle>
                                <hr />

                                <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    NIP
                                    </label>
                                    <Col md="4">
                                        <Input
                                            type="text"
                                            name="nip"
                                            value={nip}
                                            onChange={event => setNip(event.target.value)}
                                        >
                                    </Input>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    Nama
                                    </label>
                                    <Col md="4">
                                        <Input
                                            type="text"
                                            name="name"
                                            value={name}
                                            onChange={event => setName(event.target.value)}
                                        >
                                    </Input>
                                    </Col>
                                </Row>
                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Status Pegawai
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionEmployeeStatuss.filter(option => 
                                              option.value === selectedStatus.value)}
                                            onChange={handleSelectStatus}
                                            required="required"
                                            options={optionEmployeeStatuss}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row> */}
                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Unit Kerja
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionUnits.filter(option => 
                                              option.value === selectedUnit.value)}
                                            onChange={handleSelectUnit}
                                            required="required"
                                            options={optionUnits}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row> */}
                               
                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button>
                                    </Col>
                                </Row>

                                <hr />
                                
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} additionalFilter={additionalFilter}/>
                            </CardBody>
                        </Card>
                        
                       
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView